import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: ${props => props.size === 'small' ? '24px' : props.size === 'large' ? '48px' : '32px'};
  height: ${props => props.size === 'small' ? '24px' : props.size === 'large' ? '48px' : '32px'};
`;

const SpinnerCircle = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  border: ${props => props.size === 'small' ? '3px' : props.size === 'large' ? '6px' : '4px'} solid;
  border-radius: 50%;
  border-color: ${props => props.theme.colors.primary} transparent transparent transparent;
  animation: ${spin} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
`;

const LoadingSpinner = ({ size = 'medium', className }) => (
  <SpinnerWrapper size={size} className={className}>
    <SpinnerCircle size={size} />
  </SpinnerWrapper>
);

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string
};

export default LoadingSpinner; 